import { startTransition, StrictMode } from 'react';

import { isHydrationError } from '@shared/utils-frontend/is-hydration-error';
import logger from '@shared/utils-frontend/logger';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router-dom';

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
    {
      onRecoverableError: (error, errorInfo) => {
        /**
         * If the error is a hydration error and Chrome translation was detected before hydration,
         * suppress the error.
         */
        const errorMessage =
          error instanceof Error ? error.message : String(error);
        if (isHydrationError(errorMessage)) {
          logger.warn('Hydration mismatch likely caused by browser extension', {
            errorMessage,
            componentStack: errorInfo.componentStack,
          });
        } else {
          logger.error(
            'Recoverable error during hydration',
            {
              errorMessage,
              componentStack: errorInfo.componentStack,
            },
            error,
          );
        }
      },
    },
  );
});
